import { render, staticRenderFns } from "./PerformanceReviewSchedule.vue?vue&type=template&id=06312910&"
import script from "./PerformanceReviewSchedule.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports